
import Loader from 'react-loader-spinner';
import { useForm } from 'react-hook-form';
import { useDispatch } from "react-redux";
import BihamtaTable from '../BihamtaTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import ModalEnlargeImage from "../../Components/Modals/ModalEnlargeImage";
import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, Form, FormGroup, Modal, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { getImageServerPath, invoiceTypes, isWebApp, useIsMobileApp } from "../../store/api/CommonFunctions";
import { CardImage, CheckSquare, DashCircle, ExclamationCircle, EyeFill, EyeSlashFill, InfoSquareFill, PlusCircle, Search } from "react-bootstrap-icons";
import { searchBorrowPorductsForUsedParts, searchProductForSelect, searchProducts4Invoice, searchProducts4StorageReports, searchUsedParts, searchUsedPartsProduction, getAllProductMainGroups, getProductGroups, getAllProductHolders }
    from "../../store/api/GetAllProduct";
import ModalAddNewProductForSelect from './ModalAddNewProductForSelect';
const ModalProducts = (props) => {

    const btnSearch = useRef();
    const resultTable = useRef();
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const currentRowIndex = useRef(0);
    const selectedPrice = useRef(null);
    const divFiltersRef = useRef();
    const [error, setError] = useState(null);
    const [mainGroups, setMainGroups] = useState([]);
    const [showFilter, setShowFilter] = useState(true);
    const [productGroups, setProductGroups] = useState([]);
    const { handleSubmit, register } = useForm();
    const [currentRow, setCurrentRow] = useState(null);
    const selectedRows = useRef([]);
    const [searchByProduction, setProductionSearch] = useState(false);
    const [popImage, setPopImage] = useState({ show: false });
    const [modalNewProduct, setModalNewProduct] = useState({ show: false });
    const [holderList, setHolderList] = useState([]);
    const { productGrouppingType, setProductPopup, popData, defaultSalePrice, defaultSalePriceLabel, defaultStorages, hideNewProduct } = props;
    const { invoiceType, searchParts, setProductData, isGuarantee, show, value, customerCat, customerID, mainProductHardCode,
        isFormal, searchForBorrowUsedParts, staffID, staffName, forStorageReport, searchFieldName, partFilter, forPartRequest, multiSelect } = popData;

    const showStorage = (invoiceType === invoiceTypes.Sale ||
        invoiceType === invoiceTypes.PreSale ||
        invoiceType === invoiceTypes.Havaleh ||
        invoiceType === invoiceTypes.ReturnFromPurchase ||
        invoiceType === invoiceTypes.ReturnFromSale ||
        invoiceType === invoiceTypes.Borrow ||
        invoiceType === invoiceTypes.ReturnFromBorrow ||
        invoiceType === invoiceTypes.OldParts ||
        invoiceType === invoiceTypes.Transfer || searchParts || searchForBorrowUsedParts);
    const showSalePrice =
        (invoiceType === invoiceTypes.Sale ||
            invoiceType === invoiceTypes.PreSale ||
            searchParts ||
            invoiceType === invoiceTypes.Transfer ||
            invoiceType === invoiceTypes.Borrow) && defaultSalePriceLabel?.length > 0;
    const pNameTitle = (Number(productGrouppingType) === 1 ? "نام " : "نوع ") + (searchParts ? "قطعه" : "کالا");
    const [resultList, onGetData] = useState([]);
    const hideAddNew = hideNewProduct || invoiceType === invoiceTypes.OldParts || invoiceType === invoiceTypes.ReturnFromBorrow || invoiceType === invoiceTypes.ReturnFromPurchase || invoiceType === invoiceTypes.ReturnFromSale || searchForBorrowUsedParts;
    const dontSetStg = invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase || invoiceType === invoiceTypes.Resid;
    let imageclicked = false;
    function closeModal() {
        currentRowIndex.current = 0;
        selectedRows.current = [];
        selectedPrice.current = null;
        setCurrentRow(null);
        if (multiSelect) {
            setProductData([]);
        }
        else {
            setProductData(null);
        }
        setCurrentRow(null);
        setProductPopup({ show: false });
    }
    const onInputKeyDown = useCallback((e) => {
        if (e.keyCode === 27) {
            closeModal();
        }
    });
    const popover = (
        <Popover id="popInfo" style={{ fontFamily: "Vazir", fontSize: "12px", zIndex: 10002 }}>
            <Popover.Content className='bodyStyle' style={{ color: "blue" }}>
                <label style={{ padding: 0, display: "block" }}>ENTER: جستجو</label>
                <label style={{ padding: 0, display: "block" }}>ESCAPE: انصراف</label>
                {!multiSelect && <label style={{ padding: 0, display: "block" }}>▲▼: حرکت در سطرها</label>}
                {!multiSelect && <label style={{ padding: 0, display: "block" }}>SPACE: انتخاب سطر/کالا</label>}
                <label style={{ padding: 0, display: "block" }}>%: جدا کردن بخش های مختلف نام کالا</label>
                {multiSelect &&
                    <label style={{ padding: 0, display: "block" }}> برای انتخاب چند ردیف کلید CTRL را نگه دارید</label>}
            </Popover.Content>
        </Popover>
    )
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کد کالا", colName: "KalaCode", showInMobile: false },
        { colTitle: "مارک کالا", colName: "HolderName", showInMobile: true, showCondition: () => Number(productGrouppingType) !== 1 },
        { colTitle: pNameTitle, colName: "Name", showInMobile: true },
        { colTitle: "مدل کالا", colName: "Model", showInMobile: true },
        {
            colTitle: "نام انبار", colName: "StorageName", showInMobile: true, showCondition: () => showStorage,
        },
        {
            colTitle: "تعداد در فاکتور", colName: "SuggestedCount",
            showCondition: () => invoiceType === invoiceTypes.ReturnFromBorrow ||
                invoiceType === invoiceTypes.ReturnFromPurchase ||
                invoiceType === invoiceTypes.ReturnFromSale ||
                (searchForBorrowUsedParts ?? false)
        },
        {
            colTitle: "شماره فاکتور", colName: "InvoiceNumber",
            showCondition: () => invoiceType === invoiceTypes.ReturnFromBorrow ||
                invoiceType === invoiceTypes.ReturnFromPurchase ||
                invoiceType === invoiceTypes.ReturnFromSale ||
                (searchForBorrowUsedParts ?? false)
        },
        { colTitle: "تعداد در انبار", colName: "CountInStorage", showInMobile: false, showCondition: () => showStorage },

        { colTitle: "نشانی در انبار", colName: "SecondName", colType: "string", maxTextLength: 30 },
        { colTitle: <CardImage size={20} />, colName: "", showInMobile: false, showCondition: () => searchParts }

    ]
    function search(data) {
        currentRowIndex.current = 0;
        selectedRows.current = [];
        data.Skip = 0;
        data.Take = data.Take ?? 5;
        onGetData("PENDING");
        if (invoiceType) {
            data.InvoiceType = invoiceType;
            data.CustomerID = customerID;
            data.CustomerCat = customerCat;
            data.IsFormal = isFormal;
            dispatch(searchProducts4Invoice(data, onGetData));
        }
        else if (forPartRequest) {
            data.PartRequest = true;
            dispatch(searchProducts4Invoice(data, onGetData))
        }
        else if (forStorageReport) {
            searchProducts4StorageReports(data, onGetData);
        }
        else if (searchForBorrowUsedParts) {
            data.StaffID = staffID;
            searchBorrowPorductsForUsedParts(data, onGetData)
        }
        else if (searchParts) {

            searchUsedParts(data, onGetData);
        }
        else {
            data.InService = true;
            dispatch(searchProductForSelect(data, onGetData));
        }

    }
    function searchProduction(data) {
        selectedRows.current = [];
        currentRowIndex.current = 0;
        let productCode = data.Code ?? "";
        productCode = productCode.replace(/\s/g, '');
        let productName = data.Name ?? "";
        productName = productName.replace(/\s/g, '');
        let productModel = data.Model ?? "";
        productModel = productModel.replace(/\s/g, '');
        let holder = data.HolderName ?? "";
        holder = holder.replace(/\s/g, '');
        let stgName = (data.StorageName ?? "").replace(/\s/g, '');
        if (productCode === '' && productName === '' && productModel === '' && holder === '' && stgName === '') {
            onGetData({ Error: "هیچکدام از کادرهای جستجو پر نشده است" });
            return;
        }
        data.Skip = 0;
        data.Take = 5;
        searchUsedPartsProduction(data, mainProductHardCode, onGetData);
    }
    function select(index) {
        if (!show || !resultList || resultList.length === 0) {
            return;
        }
        if (index && !isNaN(index)) {
            if (multiSelect) {
                const found = selectedRows.current.find(r => r === index);
                if (found) {
                    resultTable.current.rows[index].className = "resultTableRow";
                    selectedRows.current = selectedRows.current.filter(r => r !== index);
                }
                else {
                    selectedRows.current.push(index);
                    resultTable.current.rows[index].className = "selectedResultTableRow";
                }
            }
            else {
                if (currentRowIndex.current !== 0) {
                    resultTable.current.rows[currentRowIndex.current].className = "resultTableRow";
                }
                currentRowIndex.current = index;
                resultTable.current.rows[index].className = "selectedResultTableRow";
            }
        }
        let err = null;
        if (currentRowIndex.current < 1 && selectedRows.current.length === 0) {
            err = "ردیفی انتخاب نشده است";
        }
        setError(err);
        if (err) {
            return;
        }
        if (multiSelect) {
            const data = [];
            selectedRows.current.forEach(i => {
                const row = resultList[i - 1];
                data.push({ ProductID: row.ID, ProductName: row.Name, ProductModel: row.Model, ProductCode: row.Code, HolderName: row.HolderName });
            });

            setProductData(data);
            setProductPopup({ show: false });
            onGetData([]);
            selectedRows.current = [];
            return;
        }
        const item = resultList[currentRowIndex.current - 1];
        currentRowIndex.current = 0;
        if (imageclicked) {
            imageclicked = false;
            return;
        }
        const data = {
            ProductID: item.ID,
            ProductName: item.Name,
            ProductModel: item.Model,
            ProductHardCode: item.Hard_Code,
            PurchasePrice: item.PriceList.MeanAvgPrice,
            ProductCode: item.KalaCode,
            GuaranteeTimeInMonth: Number(item.GaranteeTimeInMonth ?? 0),
            CanEditInstallDeadline: item.CanEditInstallDeadline,
            InstallDeadLine: item.InstallDeadLine
        };
        if (searchFieldName === "BarCode") {
            const inputBarCode = document.getElementById("modalProduct_BarCode");
            data.BarCode = inputBarCode.value;
        }

        if (searchParts || invoiceType) {
            if (!dontSetStg) {
                data.StorageID = item.StorageID;
                data.StorageName = item.StorageName;
            }
            data.IDForTaxOffice = item.IDForTaxOffice;
            if (!selectedPrice.current) {
                if (invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase) {
                    data.UnitPrice = item.PriceList.LastPurchasePrice ?? 0;
                }
                else if (invoiceType === invoiceTypes.Transfer) {
                    data.UnitPrice = item.PriceList.MeanAvgPrice;
                }
                else {
                    data.UnitPrice = isGuarantee === true ? item.PriceList.GauranteeSalePrice : item.PriceList[defaultSalePrice];
                }
            }
            else if (invoiceType === invoiceTypes.Sale ||
                invoiceType === invoiceTypes.PreSale ||
                invoiceType === invoiceTypes.Purchase ||
                invoiceType === invoiceTypes.PrePurchase ||
                invoiceType === invoiceTypes.PrePurchase ||
                invoiceType === invoiceTypes.Transfer ||
                invoiceType === invoiceTypes.Borrow ||
                searchParts) {
                data.UnitPrice = selectedPrice.current;
            }
            data.SuggestedCount = (item.SuggestedCount ?? 0) <= 0 ? 1 : item.SuggestedCount;
            if (invoiceType === invoiceTypes.ReturnFromBorrow ||
                invoiceType === invoiceTypes.ReturnFromPurchase ||
                invoiceType === invoiceTypes.ReturnFromSale) {
                data.ParentDetailID = item.ParentDetailID;
                data.UnitPrice = item.PriceList.LastSalePrice;
                data.Tax = item.Tax;
                data.TaxPercent = item.TaxPercent;
                data.Discount = item.Discount;
                data.DiscountPercent = item.DiscountPercent;
            }
        }
        else if (searchForBorrowUsedParts) {
            data.UnitPrice = item.PriceList.LastSalePrice;
            data.InvoiceDetailID = item.ParentDetailID;
            data.StorageID = item.StorageID;
            data.StorageName = item.StorageName;
            data.SuggestedCount = item.SuggestedCount;
        }
        data.HolderName = item.HolderName;
        if (setProductData) {
            setProductData(data);
        }
        setProductPopup({ show: false });
        selectedPrice.current = null;
        setCurrentRow(null);
        onGetData([]);
    }
    function magnify(imageName) {
        const onSuccess = (res) => {
            if (res.FilePath) {
                setPopImage({ show: true, imageUrl: res.FilePath });
            }
        }
        if (imageName && imageName !== "") {
            imageclicked = true;
            getImageServerPath(imageName, onSuccess);
        }
    }
    function tableKeyDown(e) {
        if (!show || multiSelect) {
            return;
        }
        if (e.key === ' ') {
            select();
        }
        else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            if (resultTable.current.rows.length > 0) {
                if (e.key === "ArrowDown" && currentRowIndex.current === resultTable.current.rows.length - 1) {
                    currentRowIndex.current = 0;
                }
                else if (e.key === "ArrowUp" && currentRowIndex.current <= 1) {
                    currentRowIndex.current = resultTable.current.rows.length;
                }
                if (e.key === "ArrowDown") {
                    currentRowIndex.current++;
                }
                else {
                    currentRowIndex.current--;
                }
                if (e.key === "ArrowDown" && currentRowIndex.current > 1) {
                    resultTable.current.rows[currentRowIndex.current - 1].className = "resultTableRow";
                }
                else if (e.key === "ArrowDown" && currentRowIndex.current === 1) {
                    resultTable.current.rows[resultTable.current.rows.length - 1].className = "resultTableRow";
                }
                if (e.key === "ArrowUp" && currentRowIndex.current < resultTable.current.rows.length - 1) {
                    resultTable.current.rows[currentRowIndex.current + 1].className = "resultTableRow";
                }
                else if (e.key === "ArrowUp" && currentRowIndex.current === resultTable.current.rows.length - 1) {
                    resultTable.current.rows[1].className = "resultTableRow";
                }
                resultTable.current.rows[currentRowIndex.current].className = "selectedResultTableRow";
                setCurrentRow({ ...resultList[currentRowIndex.current - 1] });
            }
        }
        else if (e.keyCode === 27) {
            closeModal();
        }
    }
    function handleRowClick(row) {
        const index = row.RowIndex + 1;
        resultTable.current.rows[index].className = "selectedResultTableRow";
        if (multiSelect) {
            if (row.ctrlIsDown) {
                const found = selectedRows.current.find(r => r === index);
                if (found) {
                    resultTable.current.rows[index].className = "resultTableRow";
                    selectedRows.current = selectedRows.current.filter(r => r !== index);
                }
                else {
                    selectedRows.current.push(index);
                }
            }
            else {
                selectedRows.current.forEach(r => resultTable.current.rows[r].className = "resultTableRow");
                selectedRows.current = [index];

            }
        }
        else {
            if (currentRowIndex.current !== 0) {
                resultTable.current.rows[currentRowIndex.current].className = "resultTableRow";
            }
            currentRowIndex.current = index;
            setCurrentRow(resultList[currentRowIndex.current - 1]);
        }

    }
    function showModalNewProduct() {
        setModalNewProduct({
            productGroupingType: productGrouppingType,
            show: true,
            setProductData: setProductData,
            defaultStorages: defaultStorages,
            dontSetStg: dontSetStg
        });
        closeModal();
    }

    function onMGSelect(e) {
        if (Number(e.target.value) > 0) {
            getProductGroups(e.target.value, setProductGroups);
        }
        else {
            setProductGroups([]);
        }
    }
    function showHideFilter(hide) {
        const divFilters = divFiltersRef.current;
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    useEffect(() => {
        if (show) {
            const inputID = "modalProduct_" + (searchFieldName ?? "Name");
            const inputPName = document.getElementById(inputID);
            if (inputPName) {
                if (value && value !== ' ' && inputPName.value === "") {
                    inputPName.value = value;
                }
                inputPName.focus();
            }
        }
        if (show) {
            if (Number(productGrouppingType) === 1)
                getAllProductMainGroups(setMainGroups);
            else {
                getAllProductHolders(1, setHolderList);
            }
        }
        document.addEventListener('keydown', tableKeyDown);

        return () => {
            document.removeEventListener('keydown', tableKeyDown);
        };
    }, [value, resultList, show])
    return (
        <Fragment>
            <ModalAddNewProductForSelect popData={modalNewProduct} setPopData={setModalNewProduct} />
            <Modal size='xl' show={show} style={{ direction: "rtl", zIndex: 1100 }} onHide={() => { }}>
                <Modal.Header className='headerStyle'>
                    <span>
                        <FontAwesomeIcon icon={faListAlt} size='lg' /> &nbsp;
                        انتخاب کالا از لیست
                    </span>
                    <span onClick={closeModal} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faTimes} size='lg' /></span></Modal.Header>
                <Modal.Body className='bodyStyle'>
                    <ModalEnlargeImage popData={popImage} setPopData={setPopImage} />
                    <form onSubmit={handleSubmit(searchByProduction ? searchProduction : search)}>
                        <Row className="rowBorder" ref={divFiltersRef}>
                            {searchParts ?
                                <div className='rowTitle' style={{ direction: "" }}>
                                    <input type='checkbox' className='form-check-input' onChange={e => setProductionSearch(e.target.checked)} />
                                    &nbsp;
                                    <label>جستجو بر اساس فرمول ساخت</label>
                                </div> :
                                <div className="rowTitle">
                                    فیلترهای جستجو
                                    &nbsp;
                                    {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                    {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                </div>
                            }
                            {showStorage
                                &&
                                <Col md={2} xs={6} className="form-group">
                                    <input type='text' placeholder='نام انبار' className="tableRowInput" name="StorageName" ref={register({})}
                                        defaultValue={invoiceType === invoiceTypes.ReturnFromBorrow || invoiceType === invoiceTypes.OldParts ? "" : staffName ?? defaultStorages?.SrcStorageName ?? ""} />
                                </Col>
                            }
                            {/* {(Number(productGrouppingType) === 1) &&

                                <Col md={2} className="form-group">
                                    <input type="text" id="modalProduct_Code" placeholder="کد کالا" className="form-control" name="Code" ref={register({})} onKeyDown={onInputKeyDown} />
                                </Col>
                            } */}
                            <Col md={2} xs={6} className="form-group">
                                <input id="modalProduct_Name" type="text" placeholder={(Number(productGrouppingType) === 1) ? ('نام کالا') : ('نوع کالا')}
                                    className="tableRowInput" ref={register({})} name="Name" onKeyDown={onInputKeyDown} />
                            </Col>
                            {Number(productGrouppingType) !== 1 &&
                                <Col md={2} xs={6} className="form-group">
                                    {/* <input type="text" placeholder="مارک کالا" className="tableRowInput" ref={register({})} name="HolderName" onKeyDown={onInputKeyDown} /> */}
                                    {holderList === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {holderList && Array.isArray(holderList) &&
                                        <select name="HolderID" ref={register({})} className="tableRowInput"
                                        >
                                            <option value="">مارک کالا را انتخاب کنید</option>
                                            {holderList.map((item, i) => <option key={i} value={item.ID}>{item.HolderName}</option>)}
                                        </select>
                                    }


                                </Col>
                            }
                            <Col md={2} xs={6} className="form-group">
                                <input type="text" id="modalProduct_Model" placeholder="مدل کالا" className="tableRowInput" ref={register({})} name="Model" />
                            </Col>
                            <Col md={2} xs={6} className='form-group'>
                                <input className='tableRowInput' placeholder='نشانی در انبار' ref={register({})} name="SecondName" />
                            </Col>
                            <Col md={2} xs={6} className='form-group'>
                                <input className='tableRowInput' placeholder='کد کالا' ref={register({})} name="Code" />
                            </Col>
                            <Col md={2} xs={6} className='form-group' >
                                <input className='tableRowInput' placeholder="بارکد کالا" ref={register({})} name="BarCode" id="modalProduct_BarCode" />
                            </Col>
                            <Col md={2} xs={6} className='form-group'>
                                <input className='tableRowInput' placeholder='شرح کالا' ref={register({})} name="Importer" />
                            </Col>
                            <Col md={2} xs={6} className="form-group">
                                <select className="tableRowInput" ref={register({})} name="ProductOrPart" defaultValue={searchParts || partFilter ? true : false}>
                                    <option value="">محصول یا قطعه</option>
                                    <option value={false}>محصول</option>
                                    <option value={true}>قطعه</option>
                                </select>
                            </Col>
                            {Number(productGrouppingType) === 1 &&
                                <Fragment>
                                    <Col md={2} xs={6} className='form-group'>
                                        <select className='tableRowInput scThin' ref={register({})} name='MainGroupID' onChange={onMGSelect}>
                                            <option value=''>گروه اصلی</option>
                                            {Array.isArray(mainGroups) &&
                                                mainGroups.map((mg, i) => <option key={i} value={mg.MainGroupID}>{mg.MainGroupName}</option>)}
                                        </select>
                                    </Col>
                                    <Col md={2} xs={6} className='form-group'>
                                        <select className='tableRowInput scThin' ref={register({})} name='GroupID'>
                                            <option value=''>گروه فرعی</option>
                                            {Array.isArray(productGroups) &&
                                                productGroups.map((pg, i) => <option key={i} value={pg.GroupID}>{pg.GroupName}</option>)}
                                        </select>
                                    </Col>
                                </Fragment>
                            }
                            <Col md={2} xs={6} className="form-group" >
                                <select className='tableRowInput' defaultValue={100} ref={register({})} name="Take">
                                    <option value={5}>نمایش 5 ردیف در صفحه</option>
                                    <option value={10}>نمایش 10 ردیف در صفحه</option>
                                    <option value={20}>نمایش 20 ردیف در صفحه</option>
                                    <option value={50}>نمایش 50 ردیف در صفحه</option>
                                    <option value={100}>نمایش 100 ردیف در صفحه</option>
                                </select>
                            </Col>
                        </Row>
                        <Button variant='secondary' className='mt-2 mb-2 group-Btn' type='submit' ref={btnSearch}><Search />&nbsp;جستجوی کالا</Button>
                        {!hideAddNew && <Button className='mt-2 mb-2 group-Btn' onClick={showModalNewProduct}><PlusCircle size={17} />&nbsp; کالای جدید</Button>}
                    </form>
                    <BihamtaTable forceRowClickInMobile={true} columns={tableColes} tableRef={resultTable} style={{ whiteSpace: "noWrap" }} rowClick={handleRowClick}
                        dataList={(resultList === "PENDING" || resultList.Error) ? resultList : { Data: resultList }} rowDoubleClick={(row) => select(row.RowIndex + 1)} maxHeight={320} className="mt-0 mb-0" />
                    {currentRow && (invoiceType === invoiceTypes.Sale || invoiceType === invoiceTypes.PreSale || invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase || searchParts || invoiceType === invoiceTypes.Transfer || invoiceType === invoiceTypes.Borrow) &&
                        <div className="d-flex gap-2" style={{ padding: "10px", color: "blue", borderRadius: "3px", background: "linear-gradient(-45deg, #f3e4e4, transparent)", fontSize: "11px" }}>
                            {(invoiceType === invoiceTypes.Sale || invoiceType === invoiceTypes.PreSale || searchParts /*|| invoiceType === invoiceTypes.Transfer*/ || invoiceType === invoiceTypes.Borrow) && !isMobile &&
                                <>
                                    <div className='product-price-item'>
                                        <input className='form-check-input' id="chkSalePrice" type='radio' name="SelectedPrice"
                                            onChange={() => selectedPrice.current = currentRow.PriceList.SalePrice ?? 0} defaultChecked={defaultSalePrice === "SalePrice"} style={{ margin: "3px" }} />
                                        <label htmlFor="chkSalePrice" className="vertical-middle">بهای فروش:&nbsp;</label>
                                        <label style={{ color: "#bb0e5f" }} className="vertical-middle" htmlFor="chkSalePrice">{currentRow.PriceList.SalePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                    </div>
                                    <div className='product-price-item'>
                                        <input className='form-check-input' id="chk3rdSalePrice" type='radio' name="SelectedPrice" defaultChecked={defaultSalePrice === "SalePrice3"}
                                            onChange={() => selectedPrice.current = currentRow.PriceList.SalePrice3 ?? 0} style={{ margin: "3px" }} />
                                        <label htmlFor="chk3rdSalePrice" className="vertical-middle">بهای فروش سوم:&nbsp;</label>
                                        <label htmlFor="chk3rdSalePrice" style={{ color: "#bb0e5f" }} className="vertical-middle">{currentRow.PriceList.SalePrice3?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                    </div>
                                    <div className='product-price-item'>
                                        <input className='form-check-input' id="chkGuaranteeSalePrice" type='radio' name="SelectedPrice" defaultChecked={defaultSalePrice === "GauranteeSalePrice"}
                                            onChange={() => selectedPrice.current = currentRow.PriceList.GauranteeSalePrice ?? 0} style={{ margin: "3px" }} />
                                        <label htmlFor="chkGuaranteeSalePrice" className="vertical-middle">بهای فروش گارانتی:&nbsp;</label>
                                        <label htmlFor="chkGuaranteeSalePrice" className="vertical-middle" style={{ color: "#bb0e5f" }}>{currentRow.PriceList.GauranteeSalePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>

                                    </div>
                                    <div className='product-price-item'>
                                        <input className='form-check-input' id="chkLastSalePrice" type='radio' name="SelectedPrice" defaultChecked={defaultSalePrice === "LastSalePrice"}
                                            onChange={() => selectedPrice.current = currentRow.PriceList.LastSalePrice ?? 0} style={{ margin: "3px" }} />
                                        <label htmlFor="chkLastSalePrice" className="vertical-middle">بهای آخرین فروش:&nbsp;</label>
                                        <label style={{ color: "#bb0e5f" }} className="vertical-middle" htmlFor="chkLastSalePrice">{currentRow.PriceList.LastSalePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                    </div>
                                </>
                            }
                            {(invoiceType === invoiceTypes.Purchase || invoiceType === invoiceTypes.PrePurchase || invoiceType === invoiceTypes.Sale || invoiceType === invoiceTypes.PreSale) && !isMobile &&
                                <>
                                    <div className='product-price-item'>
                                        <input className='form-check-input' id="chkMeanAvgPrice" type='radio' name="SelectedPrice" style={{ margin: "3px" }} defaultChecked={defaultSalePrice === "MeanAvgPrice"}
                                            onChange={() => selectedPrice.current = currentRow.PriceList.MeanAvgPrice ?? 0} />
                                        <label htmlFor="chkMeanAvgPrice" className="vertical-middle">میانگین موزون:&nbsp;</label>
                                        <label htmlFor="chkMeanAvgPrice" className="vertical-middle" style={{ color: "#bb0e5f" }}>{currentRow.PriceList.MeanAvgPrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                    </div>
                                    <div className='product-price-item'>
                                        <input className='form-check-input' id="chkPurchasePrice" type='radio' name="SelectedPrice" style={{ margin: "3px" }} defaultChecked={defaultSalePrice === "PurchasePrice"}
                                            onChange={() => selectedPrice.current = currentRow.PriceList.PurchasePrice ?? 0} />
                                        <label htmlFor="chkPurchasePrice" className="vertical-middle">بهای خرید:&nbsp;</label>
                                        <label htmlFor="chkPurchasePrice" className="vertical-middle" style={{ color: "#bb0e5f" }}>{currentRow.PriceList.PurchasePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                    </div>
                                    <div className='product-price-item'>
                                        <input className='form-check-input' id="chkLastPurchasePrice" type='radio' name="SelectedPrice" style={{ margin: "3px" }} defaultChecked={defaultSalePrice === "LastPurchasePrice"}
                                            onChange={() => selectedPrice.current = currentRow.PriceList.LastPurchasePrice ?? 0} />
                                        <label htmlFor="chkLastPurchasePrice" className="vertical-middle">بهای آخرین خرید:&nbsp;</label>
                                        <label htmlFor="chkLastPurchasePrice" className="vertical-middle" style={{ color: "#bb0e5f" }}>{currentRow.PriceList.LastPurchasePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</label>
                                    </div>
                                </>
                            }
                        </div>
                    }

                    <div className='mt-2'>
                        <div style={{ direction: "rtl" }}>
                            <Button variant='info' className='group-Btn' onClick={select}><CheckSquare size={16} />&nbsp;انتخاب کالا&nbsp;</Button>
                            <Button variant='danger' className='group-Btn' onClick={closeModal}><DashCircle size={16} />&nbsp;انصراف&nbsp;</Button>
                        </div>
                        {!isMobile &&
                            <OverlayTrigger overlay={popover} trigger={["hover", "focus"]}>
                                <InfoSquareFill size={25} color='#ff5500' style={{ position: "absolute", left: "10px", bottom: "10px" }} />
                            </OverlayTrigger>
                        }
                    </div>
                    {invoiceType === invoiceTypes.ReturnFromSale &&
                        <Alert variant='warning' style={{ maxWidth: "50%" }} className='mt-2'><ExclamationCircle size={18} /> &nbsp; اگر قصد ارسال فاکتور به سازمان مالیات را دارید، کالاها را از یک فاکتور انتخاب کنید</Alert>
                    }
                </Modal.Body>
            </Modal >
        </Fragment>
    )
}
export default ModalProducts;